import { Validators } from '@angular/forms';

export const FaqSchema = {
  'fields': [
    {
      'field': 'id',
      'value': '',
      'validators': []
    },
    {
    'field': 'question',
    'value': '',
    'validators': [Validators.required, Validators.minLength(1)]
  }, {
    'field': 'answer',
    'value': '',
    'validators': [Validators.required, Validators.minLength(1)]
  }]
}

export const RegistrationSchema = {
  'fields': [
    {
      'field': 'id',
      'value': '',
      'validators': []
    },
    {
      'field': 'registrationType',
      'value': 0,
      'validators': [Validators.required]
    },
    {
      'field': 'campaignId',
      'value': '',
      'validators': []
    },
    {
      'field': 'label',
      'value': '',
      'validators': [Validators.required, Validators.maxLength(16)]
    }, {
      'field': 'link',
      'value': '',
      'validators': []
    },
    {
      'field': 'desc',
      'value': '',
      'options': {
        'getter': (control) => {
            const reg = new RegExp(String.fromCharCode(160), 'g');
            return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
        }
    }
    }]
}
